import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ClickOutsideModule } from 'ng-click-outside';
import { FormsModule } from '@angular/forms';
import { UiPipesModule } from '@netfoundry-ui/ui/pipes';
import { SideNavigatorComponent } from './side-navigator/side-navigator.component';
import { FeatureItemSelectorModule } from "@netfoundry-ui/feature/item-selector";
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ZitiWasmModule } from '@netfoundry-ui/shared/ziti-wasm';

@NgModule({
    imports: [CommonModule, RouterModule, ClickOutsideModule, FontAwesomeModule, FormsModule, UiPipesModule, FeatureItemSelectorModule, ScrollingModule, ZitiWasmModule],
    declarations: [SideNavigatorComponent],
    exports: [SideNavigatorComponent],
})
export class FeatureNavigatorModule {}
